import { jsxs as v, jsx as e } from "react/jsx-runtime";
import { E as d, S as f } from "./icons.types-0722eef5.js";
function p({ title: i, titleId: o, size: c, width: s, height: n, extended: h = !1, ...r }) {
  const l = h ? d : f, t = c ? l[c] : s || l[h ? "s" : "l"], a = c ? l[c] : n || l[h ? "s" : "l"];
  return /* @__PURE__ */ v(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      width: t,
      height: a,
      "aria-labelledby": o,
      ...r,
      children: [
        i ? /* @__PURE__ */ e("title", { id: o, children: i }) : null,
        /* @__PURE__ */ e(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M20.39 4c2.465 0 4.075 1.434 4.976 4.001l.957 2.406h2.247c1.512 0 2.763 1.314 2.763 2.934 0 1.289-.793 2.385-1.879 2.778a4.32 4.32 0 0 1 .917 2.661v6.286c0 1.625-1.133 2.934-2.643 2.934h-1.924c-1.462 0-2.57-1.227-2.64-2.78H8.836C8.766 26.773 7.657 28 6.196 28H4.271c-1.51 0-2.642-1.31-2.642-2.934V18.78c0-.97.325-1.914.917-2.66-1.086-.394-1.88-1.49-1.88-2.78 0-1.619 1.252-2.933 2.763-2.933h2.248l.961-2.416C7.728 5.331 9.188 4 11.609 4h8.781Zm0 2h-8.78c-1.534 0-2.391.781-3.206 2.768L7.201 11.79a.959.959 0 0 1-.885.617H3.43c-.45 0-.846.416-.846.934s.396.934.846.934h.963c.797 0 1.246.957.756 1.614l-1.102 1.475c-.329.413-.5.91-.5 1.416v6.286c0 .563.32.934.725.934h1.925c.405 0 .726-.37.726-.934v-.846c0-.552.429-1 .958-1h16.24c.529 0 .958.448.958 1v.846c0 .563.32.934.726.934h1.924c.405 0 .726-.37.726-.934V18.78c0-.507-.172-1.003-.52-1.44l-1.082-1.45c-.49-.658-.042-1.615.756-1.615h.962c.45 0 .846-.417.846-.934 0-.518-.396-.934-.846-.934h-2.887a.959.959 0 0 1-.885-.617L23.581 8.73C22.92 6.849 21.967 6 20.39 6Zm.01 4.126c.482-.23 1.05-.009 1.27.493l.877 2c.29.663-.174 1.416-.872 1.416h-11.5c-.697 0-1.161-.753-.871-1.416l.876-2c.22-.502.789-.723 1.27-.493.482.23.693.823.473 1.325l-.256.584h8.517l-.256-.584c-.22-.502-.009-1.096.473-1.325Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
export {
  p as Vehicle
};
